module.exports = "/images/plus.svg?1498348b64326736cc76c415881dcd88";